const DEFAULT_USR_ERR = "Error while contacting our server"

export default {
  INVALID_API_REQUEST_PARAMS: { USR_MSG: DEFAULT_USR_ERR, DEV_MSG: "Invalid API request params"},
  UNKNOWN_API_ACTION_TYPE: { USR_MSG: DEFAULT_USR_ERR, DEV_MSG: "Unknown API action type"},
  NO_API_DEFINITION_FOR_ACTION_TYPE: { USR_MSG: DEFAULT_USR_ERR, DEV_MSG: "No API definition for action type"},
  REQUIRED_API_AUTH_TOKEN_MISSING: { USR_MSG: DEFAULT_USR_ERR, DEV_MSG: "API token is required, but is missing from request"},
  API_CALL_ERROR: { USR_MSG: DEFAULT_USR_ERR, DEV_MSG: "Error while trying to contact API"},
}